// test286
(286 && 0);
